// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BJtD","productName":"Table_productName__2LEV4"};